import React, { useEffect } from "react";
import { Helmet } from "react-helmet";

import WithFormLayout from "../formLayout";
import { Typography } from "antd";
import { sendVerifyEmail } from "../../../api/emailVerification";
import { useSignupContext } from "../../../context/SignupContext";

//google tag manager
import { useAppContext } from "../../../context/AppContext";
import { GTM_pageview, GTM_signupComplete } from "../../../utils/googleTagManager";
import StepLayout from "../../layouts/stepLayout";

const { Paragraph } = Typography;

const EmailVerification = () => {
    const {
        state: { signupParams, loading },
        dispatch: signupDispatch,
    } = useSignupContext();

    const {
        state: { cart },
    } = useAppContext();

    useEffect(() => {
        //google tag manager pageview
        GTM_pageview("Activation | MailChannels", "/pricing/activation");
        //google tag manager ecommerce
        GTM_signupComplete(cart);
    }, []);

    return (
        <StepLayout>
            <Helmet>
                <title>{`Activation | MailChannels`}</title>
            </Helmet>
            <WithFormLayout
                loading={Boolean(loading)}
                title={`You're Almost There!`}
                subTitle={`Activate your account to finish signing up.`}
                splitLayout={false}
            >
                <Paragraph style={{ textAlign: "left" }}>
                    {`We've sent you a welcome email along with activation link. Simply click the link from the email and you're good to go.`}
                </Paragraph>
                <Paragraph style={{ textAlign: "left" }}>
                    {`If you didn't receive the email, `}
                    <a
                        href="# "
                        onClick={() => sendVerifyEmail(signupParams.email, signupDispatch)}
                    >
                        {`click here`}
                    </a>
                    {` and we'll send you a new activation link.`}
                </Paragraph>
            </WithFormLayout>
        </StepLayout>
    );
};

export default EmailVerification;
